import { render, staticRenderFns } from "./percent-report.vue?vue&type=template&id=597aa3f2"
import script from "./percent-report.vue?vue&type=script&lang=js"
export * from "./percent-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports